






















import {Component, PropSync} from 'vue-property-decorator'
import {Action} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {UserRoleFilter} from "@/store/user_management/roles/types";
import {SelectWings, ToggleWings, InputWings} from "wings-ui-components";
import {notifyError} from "@/utils/notify-helper";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({components: {SelectWings, ToggleWings, InputWings}})
export default class UserRolesFilter extends BaseFilter<UserRoleFilter>{
  @PropSync('show') is_show!: boolean;
  @Action("getUserRoles") actionGetUserRoles: any;
  @Action("exportUserRoles") actionExportUserRoles: any;

  defaultFilter(): UserRoleFilter {
    return {
      name: undefined,
    };
  }

  created() {
    this.filtered();
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "System account role",
        addititional_info: getTranslatedParams(this.filter)
      }
      this.actionGetUserRoles(this.filter);
      await this.actionLog(this.logObject);
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

  export(): void {
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Export",
      action_status: "success",
      object_type: "System account role",
      addititional_info: getTranslatedParams(this.filter)
    }
    this.actionExportUserRoles(this.filter).then(()=>{
        this.actionLog(this.logObject);
      }).catch((error:any) => {
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      })
  }
}
